import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import { BillingPlanTier, Currency } from '@core/billing-types';
import { NgTemplateAssertType, trackByValue } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { RtPlanButtonVariant } from '@core/user-interface-legacy';
import {
  DividerComponent,
  HeadingComponent,
  IconComponent,
  PlanButtonComponent,
} from '@core/user-interface-legacy';

import { JobSlotsLimitMessageComponent } from '../../job-slots-limit-message/job-slots-limit-message.component';
import { JobSlotsPickerComponent } from '../../job-slots-picker/job-slots-picker.component';
import { PlanPickerProductCtaLabelPipe } from '../plan-picker-product-cta-label.pipe';
import { PlanPickerProductHeaderComponent } from '../plan-picker-product-header/plan-picker-product-header.component';
import { PlanPickerProductPriceComponent } from '../plan-picker-product-price/plan-picker-product-price.component';
import { PlanPickerAnalytics } from '../plan-picker.analytics';
import { PlanPickerModel } from '../plan-picker.model';
import type { PlanPickerProduct, PlanPickerState } from '../plan-picker.types';

@Component({
  selector: 'rt-plan-picker-products',
  templateUrl: './plan-picker-products.component.html',
  styleUrls: ['./plan-picker-products.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    DividerComponent,
    NgTemplateAssertType,
    PlanPickerProductHeaderComponent,
    PlanPickerProductPriceComponent,
    HeadingComponent,
    JobSlotsPickerComponent,
    JobSlotsLimitMessageComponent,
    PlanButtonComponent,
    IconComponent,
    TranslatePipe,
    PlanPickerProductCtaLabelPipe,
  ],
})
export class PlanPickerProductsComponent {
  public readonly templateTypeProduct: { $implicit: PlanPickerProduct };
  public readonly Currency = Currency;
  public readonly BillingPlanTier = BillingPlanTier;

  public selected = output<PlanPickerProduct>();
  public slotsChange = output<{
    codename: BillingPlanTier;
    value: number;
  }>();
  public cancelSubscription = output<void>();

  @Input() public state: PlanPickerState;

  public trackByFeature = trackByValue;

  public planTierButtonVariantMap: Record<BillingPlanTier, RtPlanButtonVariant> = {
    [BillingPlanTier.Launch]: 'launch',
    [BillingPlanTier.Scale]: 'scale',
    [BillingPlanTier.Lead]: 'lead',
    [BillingPlanTier.Start]: 'start',
    [BillingPlanTier.Grow]: 'grow',
    [BillingPlanTier.Optimize]: 'optimize',
  };

  constructor(
    public content: PlanPickerModel,
    public analytics: PlanPickerAnalytics,
  ) {}

  public trackByProduct(index: number, { codename, product }: PlanPickerProduct) {
    return `${codename}#${product?.id}`;
  }

  public trackByRef(index: number, ref: TemplateRef<any>) {
    return ref;
  }
}
